import * as types from '../constants/ActionTypes';
import { browserHistory } from 'react-router';
import { sendToApiNoHeaders } from '../../lib/sendToApi';

export function reloadUserData(user) {
  return {
    type: types.RELOAD_USER_DATA,
    payload: user
  }
}

// Used for logout
export function resetUserData() { 
  return {
    type: types.RESET_USER_DATA
  };
}

// Update User
function setUpdateUserPending(isUpdateUserPending) {
  return {
    type: types.SET_UPDATE_USER_PENDING,
    isUpdateUserPending
  };
}

function setUpdateUserSuccess(isUpdateUserSuccess) {
  return {
    type: types.SET_UPDATE_USER_SUCCESS,
    isUpdateUserSuccess
  };
}

function setUpdateUserError(updateUserError) {
  return {
    type: types.SET_UPDATE_USER_ERROR,
    updateUserError
  };
}

export function updateUser(data) {
  return dispatch => {
    dispatch(setUpdateUserPending(true));
    dispatch(setUpdateUserSuccess(false));
    dispatch(setUpdateUserError(null));

    sendToApiNoHeaders('api/updateUser', data).then((payload) =>  {
      dispatch(setUpdateUserPending(false));
      if(payload[0].status === 200) {
        dispatch(reloadUserData(payload[1].user));
        browserHistory.push('/'); 
      } else {
        dispatch(setUpdateUserError(error));
      }
    }).catch((payload) => {});
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/User.js